import React from 'react';
import {Route, Routes} from 'react-router-dom';

import NotFound from './notFound';
import ServerError from './serverError';
import classNames from './styles.module.scss';

export default () => (
  <div className={classNames.error}>
    <Routes>
      <Route path="/error/server" element={<ServerError />} />
      <Route path="/error/notfound" element={<NotFound />} />
    </Routes>
  </div>
);
